import { render, staticRenderFns } from "./asideList.vue?vue&type=template&id=7ed0e09e"
import script from "./asideList.vue?vue&type=script&lang=js"
export * from "./asideList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports